import axios from "axios";
import Config from "../../config/config";

const getListaPedidosSeparados = data => {
    return axios({
        method: "post",
        url: "https://api.katuxa.com.br/api/v1/apps/pdv/relatorios/vendas/getListaPedidosSeparados",
        data
    });
};

export default getListaPedidosSeparados;
